export class LoginCredential {
    userName: string;
    password: string;
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/auth/login/login.credential.ts